module.exports = __webpack_public_path__ + "static/img/ap-logo.e2c673ab.png";